import template from 'text!./templates/Input.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            item: '&'
        },
        template: template,
        link: function link($scope) {
            return $scope.$watch('item()', function (item) {
                $scope.applyNewValue = function () {
                    item.setValue($scope.fakeVM.value);
                };

                $scope.fakeVM = { value: item.getValue() };
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/Input.js
// module id = 102
// module chunks = 0